import React, { useEffect, useState, useRef } from "react";
// import Carousel from "react-multi-carousel";
import Carousel from "nuka-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDataProvider } from "./DataProvider";
import videoDefault from "../assets/icons/nuevaVariante.mp4";
import { LinearProgress } from "@material-ui/core";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { Button } from "@material-ui/core";
import { pDataProvider, pDB_user_roles } from "../utils/parameters";

// const MAX_LOADING = 3;

export function VideoCarousel(props) {
  const { dialogElements, dialogPosition, setDialogPosition, isTask } = props;
  const [repoVideos, setRepoVideos] = useState([]);
  const { json_data_glosses, comm_getPublicURLVideoData } = useDataProvider();
  const [initialSlide, setInitialSlide] = useState(0);
  const { currentUserRole } = useDataProvider();
  // const [counterLoading, setCounterLoading] = useState(0);
  const [visible, setVisible] = useState(false); // False: Loading activo & display 'non' y viceversa.]
  const videoRefs = useRef([]);
  const firstLoad = useRef(true);
  const customPrevSlide = useRef(0); //MOB - This could be removed if we could modify the nextSlide and prevSlide functions of the plugin
  const [ meaning_position, setMeaning_position ] = useState(null);

  useEffect(() => {

    let vids = [];
    let vids_idx = 0;

    if (meaning_position !== dialogPosition["meaning"]){
      
      dialogElements[dialogPosition["meaning"]].forEach((item, index) => {
        let vid = {};
        vid["id"] = index;
        vid["_id"] = item;
        vid["video"] = comm_getPublicURLVideoData(pDataProvider.dir_vid_sign, item);
        vids_idx = index;
        vids.push(vid);
      });
      setMeaning_position(dialogPosition["meaning"])
  
      if (currentUserRole !== pDB_user_roles.invitated) {
        let vid = {};
        vid["id"] = vids_idx + 1;
        vid["video"] = videoDefault;
        vids.push(vid);
      }
      setRepoVideos(vids);
    }

    let position_in_array = dialogElements[dialogPosition["meaning"]].indexOf(dialogPosition["gloss"]);
    if (position_in_array === -1) {
      position_in_array = dialogElements[dialogPosition["meaning"]].length;
    }
    setInitialSlide(position_in_array);
    customPrevSlide.current = position_in_array;

    firstLoad.current = true;


    // console.log('dialogElements', dialogElements)
    // console.log('dialogPosition', dialogPosition)
    // console.log('repoVideos', vids)
    // console.log('position_in_array', position_in_array)


  }, [dialogPosition]);


  const beforeSlide = (currentSlideIndex, endSlideIndex) => {

    const current_gloss_id = dialogElements[dialogPosition["meaning"]][endSlideIndex];
    setDialogPosition({ ...dialogPosition, gloss: current_gloss_id });
    customPrevSlide.current = currentSlideIndex;
  };

  const afterSlide = (index) => {
    videoRefs.current[customPrevSlide.current].currentTime = 0;
    videoRefs.current[customPrevSlide.current].pause();
    videoRefs.current[index].play();
  };

  //MOB - Sometimes, the first video would not load properly. This should fix it.
  const loadVideo = () => {
    // if (firstLoad.current === true && videoRefs.current[0].readyState === 4) {
    if (firstLoad.current === true && videoRefs.current[0].readyState > 3) {
      setVisible(true);
      videoRefs.current[initialSlide].play();
      firstLoad.current = false;
    }
  };

  //MOB - A little "dirty", but the carousel plugin inserts 3 slides for each video to allow infinite scroll, so this is needed to only play the desired videos - Check
  let refCloneOffset = 0;
  const setVideoRefs = (ref) => {
    if (refCloneOffset === repoVideos.length) {
      if (videoRefs.current.length < repoVideos.length) {
        videoRefs.current.push(ref);
      }
    } else {
      refCloneOffset++;
    }
  };

  return (
    <>
      {repoVideos[0] !== undefined ? (
        <>
          {visible === false && <LinearProgress color="primary" />}
          <Carousel
            className="sig_SignModal_VideoContainer sig_SignModal_CarouselContainer"
            wrapAround={true}
            slidesToShow={1}
            beforeSlide={beforeSlide}
            afterSlide={afterSlide}
            slideIndex={initialSlide}
            swipeable={false}
            dragging={false}
            // disableAnimation = {true}
            speed={800}
            renderCenterLeftControls={({ previousDisabled, previousSlide }) =>
              (isTask !== true && visible === true && repoVideos.length>1) ? (
                <Button className="sig_SignModal_CarouselPrev" onClick={previousSlide} disabled={previousDisabled}>
                  <NavigateBeforeIcon fontSize="large" color="primary" />
                </Button>
              ) : (
                <></>
              )
            }
            renderCenterRightControls={({ nextDisabled, nextSlide }) =>
            (isTask !== true && visible === true && repoVideos.length>1) ? (
                <Button className="sig_SignModal_CarouselNext" onClick={nextSlide} disabled={nextDisabled}>
                  <NavigateNextIcon fontSize="large" color="primary" />
                </Button>
              ) : (
                <></>
              )
            }
            defaultControlsConfig={{
              pagingDotsClassName: isTask ? "sig_SignModal_CarouselDotsHidden": "sig_SignModal_CarouselDots",
              pagingDotsStyle: { fill: "#5ea0d4" },
            }}
          >
            {repoVideos.map((videoObj, idx) => {
              return <video ref={(v) => setVideoRefs(v)} className={`sig_SignModal_CarouselVideo ${visible ? "" : "sig_SignModal_CarouselVideoHidden"}`} key={idx} loop muted src={videoObj.video} onCanPlayThrough={() => loadVideo()} />;
            })}
          </Carousel>
        </>
      ) : (
        <></>
      )}
    </>
  );
}
export default VideoCarousel;

// {((!videoLoaded.sign && tabValue === 0) || (!videoLoaded.def && tabValue === 1)) && <LinearProgress className={styles.videoLoading} color="primary" />}

// const defaultRepo = [
//   {
//     id: 1,
//     video: "https://firebasestorage.googleapis.com/v0/b/signamed-44de6.appspot.com/o/signamed_vid_sign%2Fw0203a.mp4?alt=media&token=79844572-320e-4ceb-a89b-aaabd2abbf58",
//   },
//   {
//     id: 2,
//     video: "https://firebasestorage.googleapis.com/v0/b/signamed-44de6.appspot.com/o/signamed_vid_sign%2Fw0203a.mp4?alt=media&token=79844572-320e-4ceb-a89b-aaabd2abbf58",
//   },
//   {
//     id: 3,
//     video: "https://firebasestorage.googleapis.com/v0/b/signamed-44de6.appspot.com/o/signamed_vid_sign%2Fw0203a.mp4?alt=media&token=79844572-320e-4ceb-a89b-aaabd2abbf58",
//   },
//   {
//     id: 4,
//     video: "https://firebasestorage.googleapis.com/v0/b/signamed-44de6.appspot.com/o/signamed_vid_sign%2Fw0203a.mp4?alt=media&token=79844572-320e-4ceb-a89b-aaabd2abbf58",
//   },
//   {
//     id: 5,
